/**
 * Basic TupasPage
 * Redirects when using HTML5 history api to the provided url.
 */
import { ReduxDispatch, ReduxState } from "../../ducks/reducers";
import { connect, Dispatch } from "react-redux";
import React from "react";
import { RouteProps, Redirect } from "react-router";
import { SetHeader } from "../../ducks/common";
import {
    getTupasActionResponse,
    ITupasActionResponse,
    fetchTupasAction,
} from "../../ducks/tupas";
import FullPageSpinner from "components/FullPageSpinner/FullPageSpinner";
import { Link } from "react-router-dom";
import { Typography, Grid } from "material-ui";

/**
 * Props provided by redux
 */
interface ITupasSuccessPageStateProps {
    actionResponse?: ITupasActionResponse;
    loading: boolean;
    error: string | undefined;
}

/**
 * Dispatch functions provided by redux
 */
interface ITupasSuccessPageDispatchProps {
    SetHeaderValue: (header: string) => void;
    GetTupasAction: (query: string) => void;
}

/**
 * Combined properties of the component
 */
type ITupasSuccessPageProps = ITupasSuccessPageStateProps &
    ITupasSuccessPageDispatchProps &
    RouteProps;

class TupasSuccessPage extends React.Component<ITupasSuccessPageProps> {
    constructor(props: ITupasSuccessPageProps) {
        super(props);
    }

    componentWillMount() {
        this.props.SetHeaderValue("Tupas");
        if (this.props.location && this.props.location.search) {
            this.props.GetTupasAction(this.props.location.search);
        }
    }

    public render() {
        if (this.props.actionResponse) {
            switch (this.props.actionResponse.action) {
                //TODO:
                case 1:
                    return (
                        <Redirect
                            to={`/register/${this.props.actionResponse.hash}`}
                        />
                    );
                case 2:
                    return (
                        <Redirect
                            to={`/login/${this.props.actionResponse.hash}`}
                        />
                    );
                case 3:
                    return (
                        <Redirect
                            to={`/profile/changepassword/${this.props.actionResponse.hash}`}
                        />
                    );
                case 4:
                    return (
                        <Redirect
                            to={`/profile/createlogin/${this.props.actionResponse.hash}`}
                        />
                    );
                default:
                    return <Redirect to={"/"} />;
            }
        } else {
            return (
                <div>
                    <FullPageSpinner loading={this.props.loading} />
                    <Grid container>
                        {this.props.error && (
                            <div>
                                <Grid item xs={12}>
                                    <Typography>
                                        Varmennus epäonnistui. Ole hyvä ja yritä
                                        myöhemmin uudelleen.
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Link to={"/"}>Palaa takaisin</Link>
                                </Grid>
                            </div>
                        )}
                    </Grid>
                </div>
            );
        }
    }
}

const mapStateToProps = (state: ReduxState): ITupasSuccessPageStateProps => {
    return {
        // ...mapStateToProps
        actionResponse: getTupasActionResponse(state),
        loading: state.tupas.loading,
        error: state.tupas.error,
    };
};

const mapDispatchToProps = (
    dispatch: ReduxDispatch
): ITupasSuccessPageDispatchProps => {
    return {
        // ...mapDispatchToProps
        SetHeaderValue: (header) => {
            return dispatch(SetHeader(header));
        },
        GetTupasAction: (query) => {
            return dispatch(fetchTupasAction(query));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TupasSuccessPage);



// WEBPACK FOOTER //
// ./src/views/tupas/TupasSuccessPage.tsx